module.exports = __webpack_public_path__ + "static/media/video.df4553bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mediaDnd/video.svg
// module id = 1411
// module chunks = 1